export default __webpack_public_path__ + "static/media/ic_set_origin.6b3f97ad.svg";